export default {
  'dashboardandanalysis.analysis.test': '工專路 {no} 號店',
  'dashboardandanalysis.analysis.introduce': '指標說明',
  'dashboardandanalysis.analysis.total-sales': '總銷售額',
  'dashboardandanalysis.analysis.day-sales': '日銷售額',
  'dashboardandanalysis.analysis.visits': '訪問量',
  'dashboardandanalysis.analysis.visits-trend': '訪問量趨勢',
  'dashboardandanalysis.analysis.visits-ranking': '門店訪問量排名',
  'dashboardandanalysis.analysis.day-visits': '日訪問量',
  'dashboardandanalysis.analysis.week': '周同比',
  'dashboardandanalysis.analysis.day': '日同比',
  'dashboardandanalysis.analysis.payments': '支付筆數',
  'dashboardandanalysis.analysis.conversion-rate': '轉化率',
  'dashboardandanalysis.analysis.operational-effect': '運營活動效果',
  'dashboardandanalysis.analysis.sales-trend': '銷售趨勢',
  'dashboardandanalysis.analysis.sales-ranking': '門店銷售額排名',
  'dashboardandanalysis.analysis.all-year': '全年',
  'dashboardandanalysis.analysis.all-month': '本月',
  'dashboardandanalysis.analysis.all-week': '本周',
  'dashboardandanalysis.analysis.all-day': '今日',
  'dashboardandanalysis.analysis.search-users': '搜索用戶數',
  'dashboardandanalysis.analysis.per-capita-search': '人均搜索次數',
  'dashboardandanalysis.analysis.online-top-search': '線上熱門搜索',
  'dashboardandanalysis.analysis.the-proportion-of-sales': '銷售額類別占比',
  'dashboardandanalysis.channel.all': '全部渠道',
  'dashboardandanalysis.channel.online': '線上',
  'dashboardandanalysis.channel.stores': '門店',
  'dashboardandanalysis.analysis.sales': '銷售額',
  'dashboardandanalysis.analysis.traffic': '客流量',
  'dashboardandanalysis.table.rank': '排名',
  'dashboardandanalysis.table.search-keyword': '搜索關鍵詞',
  'dashboardandanalysis.table.users': '用戶數',
  'dashboardandanalysis.table.weekly-range': '周漲幅',
};
